<template>
  <div class="main-links" ref="mainLinks" :class="{'main-links_show':MainLinksScroll}">
    <ul class="main-links__list" v-if="arrayMainLinks && arrayMainLinks.length">
      <li class="main-links__item" v-for="(link, indexLink) in arrayMainLinks" :key="indexLink">
        <router-link :to="link.href" :title="link.name" class="main-links__item-link cf">
          <div class="main-links__item-name">{{link.name}}</div>
          <div class="main-links__item-pic">
            <img :src="'/svg/'+link.svg" :title="link.name" :alt="link.name" class="main-links__item-img">
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import utils from '../js/utils'

export default {
  name: "MainLinks",
  data () {
    return {
      arrayMainLinks: [],
      MainLinksScroll: false
    }
  },
  methods: {
    async mainLinksCreate () {
      this.arrayMainLinks = [
        {
          svg: 'resume.svg',
          name: 'Резюме',
          href: '/resume/'
        },
        {
          svg: 'portfolio.svg',
          name: 'Портфолио',
          href: '/portfolio/'
        },
        {
          svg: 'links.svg',
          name: 'Полезные ссылки',
          href: '/links/'
        },
        {
          svg: 'contacts.svg',
          name: 'Контакты',
          href: '/contacts/'
        }
      ]
    },
    checkVisible (element) {
      console.log(element.offsetHeight)
      element.offsetHeight > 0 ? this.MainLinksScroll = true : ''
    }
  },
  mounted () {
    this.mainLinksCreate()
    window.onscroll = () => {
      !this.MainLinksScroll && utils.visibileElement(this.$refs.mainLinks) ? this.MainLinksScroll = true : ''
    }
    !this.MainLinksScroll && utils.visibileElement(this.$refs.mainLinks) ? this.MainLinksScroll = true : ''
  }
}
</script>

<style lang="scss" scoped>
  .main-links {
    margin: 30px 0 0;

    @media screen and (min-width: 768px){
      margin: 40px 0 0;
    }

    &__list {
      list-style: none;
      display: block;
      position: relative;
      overflow: hidden;
      margin: -10px -5px 0;

      @media screen and (min-width: 768px){
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        flex-grow: 1;
        margin: -5px -5px 0;
      }
    }

    &__item {
      position: relative;
      transform: translateX(-500px);
      opacity: 0;
      text-align: center;
      display: inline-block;
      margin: 10px 5px 0;
      transition: opacity linear 1s, transform linear 1s;

      @media screen and (min-width: 768px){
        flex: 1 1 auto;
        margin: 5px 5px 0;
      }

      .main-links_show & {
        transform: translateX(0);
        opacity: 1;
      }

      &-link {
        display: block;
        padding: 10px;
        border: 1px solid $bg-color;;
        border-radius: 10px;
        text-decoration: none;
        transition: box-shadow linear .1s;

        @media screen and (min-width: 768px){
          padding: 20px 10px;
        }

        &:hover {
          @media screen and (min-width: 768px){
            box-shadow: inset 0 0 15px 2px $bg-color;
          }
        }
      }

      &-name {
        font-family: Roboto-Bold, sans-serif;
        @include font(14px, 30px, $bg-color);
        white-space: nowrap;
        float: right;

        @media screen and (min-width: 768px){
          float: none;
          width: auto;
          @include font(14px, 1, $bg-color);
        }

        @media screen and (min-width: 1024px){
          @include font(16px, 1, $bg-color);
        }
      }

      &-pic {
        float: left;
        margin: 0 15px 0 0;

        @media screen and (min-width: 768px){
          float: none;
          margin: 20px 0 0;
        }
      }

      &-img {
        width: 30px;
        max-width: 100%;
        height: auto;
        vertical-align: bottom;

        @media screen and (min-width: 768px){
          width: 90px;
        }

        @media screen and (min-width: 1024px){
          width: 110px;
        }
      }
    }
  }
</style>